import GatewayAxiosClient from '../GatewayAxiosClient';
import type {
  AuthenticationRequest,
  AuthenticationResponse,
  ResetPasswordRequest,
  VersionMetadata,
  LogoutResponse,
} from './types';
import { getPartnerId, getToken } from '../../session';
import axios from 'axios';
import getGatewayUri from '../getGatewayUri';
import getPartnerUri from '../getPartnerUri';

export class AuthService {
  public async authenticateUser(requestParams: AuthenticationRequest): Promise<AuthenticationResponse> {
    const partnerId = getPartnerId();
    const res = await GatewayAxiosClient.post('/sso/login', { ...requestParams, partnerId });
    return res.data;
  }
  public async changePartnerContext(newPartnerId: string) {
    const res = await GatewayAxiosClient.post(
      '/sso/changeContext',
      {
        newContextId: newPartnerId,
      },
      {
        headers: {
          authorization: getToken(),
        },
      },
    );
    return res.data;
  }
  public async requestPasswordReset(resetPasswordRequest: ResetPasswordRequest): Promise<void> {
    const res = await GatewayAxiosClient.post('/sso/passwordReset', resetPasswordRequest);
    return res.data;
  }

  public async refresh(): Promise<AuthenticationResponse> {
    // const partnerId = getPartnerId();
    const res = await GatewayAxiosClient.post('/sso/refresh');
    return res.data;
  }

  public async refreshPoll(): Promise<AuthenticationResponse> {
    const res = await GatewayAxiosClient.post('/sso/refresh-poll');
    return res.data;
  }

  public async revoke(): Promise<void | LogoutResponse> {
    const res = await GatewayAxiosClient.delete('/sso/revoke', {
      headers: {
        authorization: getToken(),
      },
    });

    return res.data;
  }

  public async logout(): Promise<any> {
    const gatewayUri = getGatewayUri();
    const partnerUri = getPartnerUri();
    window.location.href = `${gatewayUri}/logout?returnTo=${encodeURIComponent(`${partnerUri}/login`)}`;
  }

  public async getVersionMetadata(): Promise<VersionMetadata> {
    try {
      const response = await axios.get(`/version.json`);
      return response.data;
    } catch (error) {
      if (process.env.NODE_ENV === 'production') {
        console.error(error);
      }
      return {
        version: process.env.REACT_APP_VERSION,
        buildTimestamp: Date.now(),
      };
    }
  }

  public async fetchQzCert(): Promise<string> {
    try {
      const response = await GatewayAxiosClient.get(`/qz-cert`, {
        headers: {
          authorization: getToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
      return '';
    }
  }

  public async qzSign(toSign: string): Promise<string> {
    try {
      const response = await GatewayAxiosClient.get(`/qz-sign?requestToSign=${toSign}`, {
        headers: {
          authorization: getToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
      return '';
    }
  }
}
